<mat-form-field *ngIf="!formReadonlyMode"
                class="mxs-input mxs-date-picker mx-date-picker"
                [formGroup]="form"
                [ngClass]="{'hidden': hidden}"
                [matTooltip]="getValidationHint() | translate"
                [matTooltipClass]="'mxs-error-ttip'">

    <button *ngIf="isDisplayed()" matSuffix mat-icon-button type="button" aria-label="Clear"
            (click)="resetValue($event)">
        <mat-icon>clear</mat-icon>
    </button>
    <mat-datetimepicker-toggle *ngIf="!picker.disabled" matSuffix [for]="picker">
    </mat-datetimepicker-toggle>
    <mat-datetimepicker type="datetime" #picker></mat-datetimepicker>
    <mat-label>{{getLabel() | translate}}</mat-label>
    <input matInput
           [matDatetimepicker]="picker"
           [name]="name"
           [errorStateMatcher]=errorService
           [formControlName]="name"
           [required]="required"
           [max]=maxDate
           [min]=minDate
           (dateChange)="onDateChanged($event)"
           (click)="picker.open()"
    />
    <mat-hint>{{hint}}</mat-hint>
    <mat-error *ngFor="let error of getValidationMessages(true)">
        {{getError(error) | translate}}
    </mat-error>
</mat-form-field>

<mat-list-item class="mxs-readonly" *ngIf="formReadonlyMode"
               [ngClass]="{'hidden': hidden}">
    <div class="mxs-readonly_label">{{label}}</div>
    <div class="mxs-readonly_input">
        {{ getDisplayValue(form.controls[name].value | zoneDate:dateTimeFormat) }}
    </div>
</mat-list-item>
